<template>
  <model>
    <div class="wrapper">
      <div class="title"></div>
      <div class="content my-scroll" v-html="content"></div>
      <div class="btn close" @click="$router.go(-1)"></div>
    </div>
  </model>
</template>

<script>
export default {
  name: 'intro',
  data() {
    return {
      content: '',
    };
  },
  created() {
    this.content = this.$activity.intro1;
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  @include w(669);
  @include center(669);
  @include h(961);
  @include bg("intro.png");
  top: 4vh;
  z-index: 11;
}

.title {
  @include w(338);
  @include h(78);
  @include bg("intro-title.png");
  margin: auto;
  margin-top: px2rem(80);
  margin-bottom: px2rem(25);
}

.content {
  @include w(505);
  @include h(700);
  margin: auto;
  color: white;
  line-height: 1.3em;
  font-size: 0.6rem;
}

.btn.close {
  position: absolute;
  @include w(60);
  @include center(60);
  @include h(60);
  @include bg("btn-close.png");
  bottom: -2rem;
}
</style>
